import * as z from 'zod'

import { getAddressFromFields } from '@flows/configs/shared/stepUtils'
import { BaseSchema_HouseholdV1GetsafeAt as baseSchema } from '@flows/insurance/schemas'

const schema = z.preprocess(
  (values) => {
    const valuesCopy = { ...(values as Record<string, any>) }
    const address = getAddressFromFields(valuesCopy)

    return {
      ...valuesCopy,
      ...address,
      ...valuesCopy.statement_of_facts,
      number_of_previous_claims: valuesCopy.insurance_owned
        ? valuesCopy.number_of_previous_claims
        : 0,
    }
  },
  baseSchema.merge(
    z.object({
      // Dog schema has id property that should be optional for client
      dogs: baseSchema.shape.dogs
        .unwrap()
        // id prop is optional when dog doesn't exist
        .element.omit({
          id: true,
        })
        .merge(
          z.object({
            id: baseSchema.shape.dogs.unwrap().element.shape.id.optional(),
          })
        )
        .array()
        .optional(),
      gadget_coverage: baseSchema.shape.gadget_coverage.default(false),
      assistance_coverage: baseSchema.shape.assistance_coverage.default(false),
      dog_coverage: baseSchema.shape.dog_coverage.default(false),
      bike_coverage: baseSchema.shape.bike_coverage.default(false),
    })
  )
)

export default schema
